export enum OptionButtonType {
  ADD_NEW = 'ADD_NEW',
  IMPORT = 'IMPORT',
  EXPORT = 'EXPORT',
  EDIT = 'EDIT',
  DELETE = 'DELETE',
  DOWNLOAD = 'DOWNLOAD'
}
